// types
export { default as Color } from './types/Color';
export { default as Size } from './types/Size';
export { default as Placement } from './types/Placement';
export { default as IconProp } from './types/IconProp';
export { default as PillProp } from './types/PillProp';

// functions
export { default as makeCallback } from './functions/makeCallback';
export { default as makeKeyboardCallback } from './functions/makeKeyboardCallback';
export { default as makeIconFromProp } from './functions/makeIconFromProp';
export { default as makeSpinnerFromProp } from './functions/makeSpinnerFromProp';
export { default as makePillFromProp } from './functions/makePillFromProp';
export { default as emptyChildren } from './functions/emptyChildren';
export { default as getLastChild } from './functions/getLastChild';
export { default as getFirstChild } from './functions/getFirstChild';
export { default as warn } from './functions/warn';
export { default as checkOnAllowedChildren } from './functions/checkOnAllowedChildren';
